// extracted by mini-css-extract-plugin
export var cardLayout = "_ak-1";
export var paginationContainer = "_ak-0";